import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

/**
 * Page de callback après authentification cross-subdomain (mot de passe ou
 * code reçu par email). Lit access_token + refresh_token dans le hash, appelle
 * setSession() explicitement, puis redirige.
 */
export default function AuthCallbackPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash.slice(1);
    const params = new URLSearchParams(hash);
    const access_token = params.get('access_token');
    const refresh_token = params.get('refresh_token');
    // Chemin interne uniquement : `//exemple.com` est une URL absolue déguisée.
    const raw = params.get('next');
    const next = raw && raw.startsWith('/') && !raw.startsWith('//') ? raw : '/home';

    if (access_token && refresh_token) {
      supabase.auth
        .setSession({ access_token, refresh_token })
        .then(() => navigate(next, { replace: true }));
    } else {
      navigate(next, { replace: true });
    }
  }, []);

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-amber-500 border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
